import { State, appendOrRemoveValueWith } from '@btime/state-monad'
import { is, path, prop } from 'ramda'

const checkIfIsSelected =
  (selectedValue, idField = 'id') =>
  item => {
    return (
      item === selectedValue || //
      (!!prop(idField, item) && prop(idField, item) === prop(idField, selectedValue)) ||
      (!!prop(idField, item) && prop(idField, item) === selectedValue)
    )
  }

export const getOptionValue = (option, field, disableDefault) =>
  is(Object, option) ? path(is(Array, field) ? field : [field], option) : disableDefault ? null : option

export const generateOnPickerChange =
  (value, onChange, config = {}) =>
  selected => {
    const { multiple, idField = 'id', selectOnlyId } = config

    const selectedId = getOptionValue(selected, idField)
    selected = selectOnlyId ? selectedId : selected
    if (multiple) {
      const newValue = State.of(value || [])
        .map(appendOrRemoveValueWith(checkIfIsSelected(selectedId, idField), selected))
        .fold()
      onChange(newValue, selected)
      return
    }
    // `value` pode chegar como o id "puro" (ex.: Selects que guardam só o id) ou como o objeto
    // inteiro da opção selecionada (ex.: TagSelect, que guarda {id, name, color}). Comparar
    // `value === selectedId` direto quebra o toggle-off (clicar de novo na opção já selecionada
    // para limpar a seleção) sempre que `value` é um objeto, porque um objeto nunca é `===` a um
    // id escalar — o clique então cai sempre no `else` e reenvia a MESMA seleção em vez de limpar.
    // Bug real: era assim que "remover a tag" clicando na opção já marcada silenciosamente
    // reatribuía a mesma tag em vez de limpar (`tagId` nunca virava null).
    const currentId = getOptionValue(value, idField)
    if (currentId === selectedId) {
      onChange(undefined)
    } else {
      onChange(selected)
    }
  }

export const generateIsPickerSelected =
  (value, config = {}) =>
  option => {
    const { multiple, idField } = config
    if (multiple) {
      return (value || []).some(checkIfIsSelected(getOptionValue(option, idField), idField))
    }
    return checkIfIsSelected(value, idField)(option)
  }
